import { stringify } from "qs";

export function createMailto(email: string, subject: string, body?: string): string {
  return `mailto:${email}?${stringify({ subject, ...(body ? { body } : {}) })}`;
}
